import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'finder-schedule-list',
    templateUrl: './schedule-list.component.html',
    styleUrls: ['./schedule-list.component.scss']
})
export class ScheduleListComponent implements OnInit {
    @Input() separator: string;
    @Input() separatorLabel: string;
    @Input() times: Array<any>;

    isMultiLine = false;

    constructor() { }

    ngOnInit() {
        this.isMultiLine =
            (this.times && this.times.length > 0 && this.times.length !== 2) ?
                (this.times[0].startTime !== this.times[0].endTime) :
                false;
    }

}
